var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-header',[_c('Header-Bar')],1),_vm._v(" "),_c('el-container',{staticStyle:{"min-height":"90vh"}},[_c('el-aside',{attrs:{"width":"180px"}},[_c('nav-bar')],1),_vm._v(" "),_c('el-main',[_c('div',{staticClass:"main-container"},[_c('tags-view')],1),_vm._v(" "),_c('app-main')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8f30e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = null
// module chunks = 